import { Button } from "@mui/material";
import React from "react";
import { RepeatIcon } from "../../../../assets/iconsSVG/repeatIcon";

export function ButtonTransferir({ disabled, style, sx, ...props }: any) {
  return (
    <Button
      {...props}
      disabled={disabled}
      style={{
        background: "linear-gradient(268.28deg, #06D986 0%, #4A76FB 100%)",
        color: "#FFFFFF",
        marginLeft: 8,
        height: 36,
        borderRadius: 4,
        boxShadow: "none",
        textTransform: "none",
        opacity: disabled ? 0.5 : 1,
        ...style,
      }}
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        "&.Mui-disabled": {
          opacity: 0.5,
          color: "#FFFFFF",
          background: "linear-gradient(268.28deg, #06D986 0%, #4A76FB 100%)",
        },
        ...sx,
      }}
      variant="contained"
      startIcon={<RepeatIcon />}
    >
      Transferir
    </Button>
  );
}
